// 本地存储键值 token令牌
export const AUTH_TOKEN: string = "TOKEN"
// 本地存储键值 用户对象数据
export const AUTH_USER: string = "USER"
// 本地存储键值 配置
export const SETTING: string = "SETTING"